import { render, staticRenderFns } from "./HotelCarousel.vue?vue&type=template&id=403c21a4&"
import script from "./HotelCarousel.vue?vue&type=script&lang=js&"
export * from "./HotelCarousel.vue?vue&type=script&lang=js&"
import style0 from "./HotelCarousel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports